export function readPageProps<T>(): T {
    const element = document.getElementById('__PAGE_PROPS__');

    return JSON.parse(element?.textContent || '{}') as T;
}
